'use client'

import { PropsWithChildren } from 'react'

import { useBIPageView } from '@/context/BISdkContext'
import { useLayoutContext } from '@/context/LayoutContext'
import { useUAContext } from '@/context/UAContext'
import { useEnableFull3d } from '@/hooks/useEnableFull3d'
import { cn } from '@/lib/utils'

function WorldPageWrapper({ children }: PropsWithChildren) {
  const { headerHeight } = useLayoutContext()
  const enableFull3d = useEnableFull3d()
  const { isMobile } = useUAContext()

  useBIPageView()

  return (
    <main
      className="relative flex min-h-dvh flex-1 flex-col"
      style={{
        paddingTop: enableFull3d ? 0 : headerHeight,
      }}
    >
      <section
        className={cn('grid grid-cols-1 px-4', {
          'p-4s gap-12 md:px-8 md:py-6': !enableFull3d,
          'px-0': enableFull3d,
          '1.5xl:py-8 1.5xl:gap-8 lg:mx-auto lg:grid-cols-[1fr_auto] lg:grid-rows-[auto_1fr] lg:gap-4 lg:px-0 lg:py-6':
            !enableFull3d && !isMobile,
        })}
      >
        {children}
      </section>
    </main>
  )
}

export default WorldPageWrapper
